import React from 'react';
import Icon from '../../../components/AppIcon';

const ScoreOverview = ({ testResult }) => {
  const getScoreColor = (percentage) => {
    if (percentage >= 80) return 'text-success';
    if (percentage >= 60) return 'text-warning';
    return 'text-error';
  };

  const getScoreGrade = (percentage) => {
    if (percentage >= 90) return 'Excellent';
    if (percentage >= 80) return 'Very Good';
    if (percentage >= 70) return 'Good';
    if (percentage >= 60) return 'Pass';
    return 'Needs Improvement';
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-elevation-2 animate-fade-in">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-2">
            Test Results Overview
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Completed on {testResult?.completedDate} at {testResult?.completedTime}
          </p>
        </div>
        <div className="flex items-center gap-3 bg-primary/10 px-4 md:px-6 py-3 rounded-lg">
          <Icon name="Award" size={24} className="text-primary" />
          <div>
            <p className="text-xs md:text-sm text-muted-foreground">Grade</p>
            <p className="text-base md:text-lg font-semibold text-primary">
              {getScoreGrade(testResult?.percentage)}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        <div className="bg-muted/50 rounded-lg p-4 md:p-6 border border-border">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/20 flex items-center justify-center">
              <Icon name="Target" size={20} className="text-primary" />
            </div>
            <p className="text-sm md:text-base text-muted-foreground">Overall Score</p>
          </div>
          <p className={`text-3xl md:text-4xl font-bold ${getScoreColor(testResult?.percentage)} data-text`}>
            {testResult?.percentage}%
          </p>
          <p className="text-xs md:text-sm text-muted-foreground mt-2">
            {testResult?.correctAnswers} of {testResult?.totalQuestions} correct
          </p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4 md:p-6 border border-border">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-success/20 flex items-center justify-center">
              <Icon name="CheckCircle2" size={20} className="text-success" />
            </div>
            <p className="text-sm md:text-base text-muted-foreground">Correct</p>
          </div>
          <p className="text-3xl md:text-4xl font-bold text-success data-text">
            {testResult?.correctAnswers}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground mt-2">
            Questions answered correctly
          </p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4 md:p-6 border border-border">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-error/20 flex items-center justify-center">
              <Icon name="XCircle" size={20} className="text-error" />
            </div>
            <p className="text-sm md:text-base text-muted-foreground">Incorrect</p>
          </div>
          <p className="text-3xl md:text-4xl font-bold text-error data-text">
            {testResult?.incorrectAnswers}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground mt-2">
            Questions answered incorrectly
          </p>
        </div>

        <div className="bg-muted/50 rounded-lg p-4 md:p-6 border border-border">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent/20 flex items-center justify-center">
              <Icon name="Clock" size={20} className="text-accent" />
            </div>
            <p className="text-sm md:text-base text-muted-foreground">Time Taken</p>
          </div>
          <p className="text-3xl md:text-4xl font-bold text-foreground data-text">
            {testResult?.timeTaken}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground mt-2">
            Average: {testResult?.avgTimePerQuestion}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScoreOverview;